import request, { REQUEST_METHODS } from '@api/Request';
import { AdditionalInfoEndpoints } from './config';
import {
  GetAdditionalInfoDetailsResponse,
  GetAdditionalInfoRequestsResponse,
  SaveAdditionalInfoCommentRequest,
  SaveAdditionalInfoCommentResponse,
  GetAdditionalInfoRequestsParams,
} from './types';

export default class AdditionalInfoService {
  public static readonly getAdditionalInfoDetails = (
    ormAdditionalInfoActionID: string,
    requestID: number,
    version: number
  ): Promise<GetAdditionalInfoDetailsResponse> =>
    request({
      url: AdditionalInfoEndpoints.getAdditionalInfoDetails(),
      method: REQUEST_METHODS.GET,
      params: { ormAdditionalInfoActionID, requestID, version },
    });
  public static readonly saveAdditionalInfoResponse = (
    data: SaveAdditionalInfoCommentRequest
  ): Promise<SaveAdditionalInfoCommentResponse> =>
    request({
      url: AdditionalInfoEndpoints.saveAdditionalInfoResponse(),
      method: REQUEST_METHODS.POST,
      data,
    });
  public static readonly getAdditionalInfoRequests = (
    params: GetAdditionalInfoRequestsParams
  ): Promise<GetAdditionalInfoRequestsResponse> =>
    request({
      url: AdditionalInfoEndpoints.getAdditionalInfoRequests(),
      method: REQUEST_METHODS.GET,
      params,
    });
}
